










































import { autoAssignController } from '@/api/Remittances/remittances.api'
import ActionButton from '@/components/ActionButton.vue'
import AutoAssignCrudDialog from '@/components/Services/Remittances/AutoAssignCrudDialog.vue'
import TableSwitch from '@/components/TableSwitch.vue'
import { tableComposition } from '@/compositions/table'
import { defineComponent } from '@vue/composition-api'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import AutoAssignFilter from '~/components/Services/Remittances/AutoAssignFilter.vue'
import TextButton from '~/components/TextButton.vue'

export default defineComponent({
  components: {
    AutoAssignCrudDialog,
    TableSwitch,
    ActionButton,
    AutoAssignFilter,
    FlatCard,
    FlatTable,
    TextButton,
  },
  setup: () => {
    return {
      ...tableComposition(autoAssignController),
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('regions'),
          value: 'regions_data',
        },
        {
          text: this.$t('delivery_currency'),
          value: 'delivery_currency',
        },
        {
          text: this.$t('commission_currency'),
          value: 'commission_currency',
        },
        {
          text: this.$t('messenger'),
          value: 'messenger_name',
        },
        {
          text: this.$t('rate'),
          value: 'rate',
        },
        {
          text: this.$t('is_active'),
          value: 'is_active',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ],
    }
  },
})
